module.exports = __webpack_public_path__ + "media/images/home/1-5f64a3880447c20a12af4234951aa4db.png";